import React from 'react'
import './index.scss'
import { timestampToDate } from '@feedback/utils/util'

interface Props {
  timestamp: any
  children: any
}

const ItemWrap: React.FC<Props> = ({ timestamp, children }) => {
  return (
    <div className='c-item-wrapper'>
      <p className='time'>{isNaN(timestamp) ? timestamp : timestampToDate(timestamp)}</p>
      <div className='item-content'>{children}</div>
    </div>
  )
}

export default ItemWrap
